module.exports = __webpack_public_path__ + "img/20190905155716360截图20190905142315115.0f94f8d5.jpg";